// @ts-check
import { LBButton } from '@linearb/buzz';
import useExport from './useExport';
import Icon from 'components/base/Icon';

const ExportButton = ({ resourceType, keyword, tableSortBy }) => {
  const { isLoading, exportToCSV } = useExport({
    resourceType,
    keyword,
    tableSortBy
  });
  const btnText = isLoading ? 'Processing...' : 'Export CSV';
  const icon = isLoading ? (
    <Icon name='Deployed' size='small' />
  ) : (
    <Icon name='Download' size='smaller' />
  );
  return (
    <div className='ml-2'>
      <LBButton variant='outline' disabled={isLoading} onClick={exportToCSV}>
        {icon}
        {btnText}
      </LBButton>
    </div>
  );
};

export default ExportButton;
